import { FormTipTapBlockEditor } from "@circle-react-uikit/Form/FormTipTapBlockEditor/FormTipTapBlockEditor";
import { Typography } from "@circleco/compass/components/Typography";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { useImagePostModalStore } from "@/react/components/Spaces/ImageSpace/ImagePostModalCompass/store";
import type { ImagePost } from "@/react/types";
import type { Space } from "@/react/types/Space";

import { CaptionToolbar, type CaptionToolbarProps } from "./CaptionToolbar";

const DISABLED_EXTENSIONS = [
  "blockquote",
  "poll",
  "embeds",
  "slash_commands",
  "file",
  "image",
  "horizontal_rule",
  "code_block",
  "headings",
  "cta",
];

interface CaptionEditorProps {
  post: ImagePost;
  space?: Space;
}

const renderCaptionToolbar = (props: CaptionToolbarProps) => (
  <CaptionToolbar {...props} />
);

export const CaptionEditor = ({ space, post }: CaptionEditorProps) => {
  const { setIsFormDirty } = useImagePostModalStore();
  const {
    formState: { isDirty: isFormDirty },
  } = useFormContext();

  useEffect(() => {
    setIsFormDirty(isFormDirty);
  }, [isFormDirty, setIsFormDirty]);

  return (
    <div>
      <Typography variant="label-sm" color="primary">
        {t("image_space.post_modal.steps.create_post.caption_label")}
      </Typography>
      <div className="!border-solid !border-primary !mt-3 !min-w-full !rounded-md !border !p-3">
        <FormTipTapBlockEditor
          placeholder={t(
            "image_space.post_modal.steps.create_post.caption_placeholder",
          )}
          name="tiptap_body.body"
          sgidToObjectMap={post?.tiptap_body?.sgids_to_object_map || {}}
          spaceId={space?.id}
          editorClassName="min-w-full h-20 overflow-y-auto"
          disabledExtensions={DISABLED_EXTENSIONS}
          shouldShowTextModifiersMenu={false}
          toolbars={[
            {
              portalId: "create-image-post-toolbar",
              component: renderCaptionToolbar,
            },
          ]}
        />
        <div id="create-image-post-toolbar" />
      </div>
    </div>
  );
};
